import ModalForm from "./Form";
import { TEACHING_TYPE, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
	components: { ModalForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "teaching-type-table",
			rowData: {},
			formId: "teaching-type-form",
			tableColumns: [
				{
					title: "ID",
					type: "text",
					key: "type_id",
				},
				{
					title: "Code",
					type: "text",
					key: "teaching_type_code",
				},
				{
					title: "Desc",
					type: "text",
					key: "teaching_type_desc",
				},
			],
			ENDPOINT: TEACHING_TYPE,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "TeachingType",
				url: TEACHING_TYPE,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "teaching-type-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				filters: [
					// {
					//     "title": this.$t('inquiry_type'),
					//     "type": "search",
					//     "key": "date",
					//     "option": ["today", "thisMonth", "last7Days", "nextYear"]
					// },
					// {
					//     "title": this.$t('age'),
					//     "type": "range-filter",
					//     "key": "age-range",
					//     "maxTitle": this.$t('max_age'),
					//     "minTitle": this.$t('min_age'),
					//     "sign": ""
					// },
					{
						title: this.$t("is_active"),
						type: "checkbox",
						key: "is_active",
						option: [
							{ id: true, value: "Active" },
							{ id: false, value: "Inactive" },
						],
					},
					// {
					//     "title": this.$t('status'),
					//     "type": "checkbox",
					//     "key": "status",
					//     "option": [
					//         {id: 'active', value: 'Active'},
					//         {id: 'inactive', value: 'Inactive'},
					//         {id: 'invited', value: 'Invited'},
					//     ],
					// },
					// {
					//     "title": this.$t('gender'),
					//     "type": "radio",
					//     "key": "filter-with-gender",
					//     "option": [
					//         {id: 'male', value: 'Male'},
					//         {id: 'female', value: 'Female'},
					//         {id: 'other', value: 'Other'},
					//     ],
					//     "header": {
					//         "title": this.$t('want_to_filter_your_list'),
					//         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
					//     },
					// },
					// {
					//     "title": this.$t('search_and_select'),
					//     "type": "drop-down-filter",
					//     "key": "search select",
					//     "option": [],
					// },
					// {
					//     title: "Search Inquiry Type",
					//     type: "search-and-select-filter",
					//     key: "serverside_select",
					//     settings: {
					//         url: actions.DATATABLE_SERVER_SEARCH_SELECT, // this url will hit every search action
					//         modifire: (v) => {
					//             return {id: v.id, name: v.name}
					//         },
					//         per_page: 10, // default 10, you can change it any number. min 10 encourage to use
					//         queryName: 'search_selectable', // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
					//         loader: 'app-pre-loader', // default app-overlay-loder
					//         multiple: true, // default false, if you need to select multiple item so make it true
					//         params: {
					//             'type': 'type1',
					//             'isWanted': true
					//         } // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
					//     },
					//     listValueField: 'name'
					// },
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.teaching_type_id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
